const baseURL = "https://resovle360backend-production.up.railway.app/api";

export default baseURL;
